import React, { useEffect, useState } from 'react'
import { deleteItem, loadLanguages,  } from '../../utils/Network';
import { useParams } from 'react-router-dom';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import { getDefaultName, isAdmin, sortLanguages, userAvatar } from '../../utils';
import Gallery from '../Gallery';
import Navbar from '../../components/Navbar';
import Mainmenu from '../../components/Mainmenu';
import Footer from '../../components/Footer';
import SelectPublished from '../../components/select/SelectPublished';
import { ApiHttpService } from '../../utils/http/api';
import SelectCourseParticipantModal from '../../components/contest/SelectCourseParticipantModal';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import PollReportBarChart from '../../components/charts/PollReportBarChart';


export default function Poll() {

    const [poll, setPoll] = useState(null);
    const [poll_items, setPollItems] = useState(null);
    const [poll_results, setPollResults] = useState(null);
    
    const [exclude_ids, setExcludeIds] = useState([]);
    
    
    const [names, setNames] = useState(null);
    const [published, setPublished] = useState(null);
    const [languages, setLanguages] = useState(null);
    const [gallery_modal_is_open, setGalleryModalIsOpen] = useState(false);
    const [courseparticipant_modal_is_open, setCourseParticipantModalIsOpen] = useState(false);
    
    const [top_ten_mode, setTopTenMode] = useState(false);
    
    const [show_delete, setShowDelete] = useState(false);

    

    const params = useParams()
    var id= params.id

    const [image, setImage] = useState(null);
    

    const [error, setError] = useState(null);
    const [done, setDone] = useState(null);
    const [loading, setLoading] = useState(false);
    const [pageloading, setPageLoading] = useState(false);

    useEffect(() => {
        setPageLoading(true)
       
        if (id) {
            setPageLoading(true)
            ApiHttpService.loadPoll(id).then(poll => {
                setPoll(poll)
                setNames(poll.names)
                setPublished(poll.published)
                setImage(poll.image)
                
            })

            _getPollItems();
            _getPollResults();
        }
    }, [])
    
  


    const _getPollItems = () => {
      ApiHttpService.loadPollItems(id,1).then(data => {
         if(data.results)
           setPollItems(data.results)
      })
    }

    const _getPollResults = () => {
      ApiHttpService.loadPollResults(id).then(data => {
           setPollResults(data)
      })
    }





    return (
    <div class="wrapper">
        <Navbar />
        <Mainmenu />
        <div className="content-wrapper">
          <section className="content-header">
            <h3 className="box-title mt-5"></h3>
            <ol className="breadcrumb">
              <li>
                <a href="dashboard">
                  <i className="fa fa-dashboard"></i> Home
                </a>
              </li>
              <li>
                <a href="polls">Polls</a>
              </li>
              <li className="active">View</li>
            </ol>
          </section>

          <section className="content">
            <div className="row">
              <div className="col-md-12 ">
                <div className="box box-primary bg-ddd">
                  <div className="box-header with-border">
                    <h3 className="box-title">
                      Details
                    </h3>
                  </div>
                  <div className="box-body ">
                    <div className=" ">
                      {pageloading && (
                        <>
                          <div className="overlay">
                            <i className="fas fa-2x fa-sync-alt fa-spin"></i>
                          </div>
                        </>
                      )}

                      <form className="form-horizontal">
                        <div>
                          <div className="col-md-7">
                              <h1>{getDefaultName(poll?.names)}</h1>
                          </div>
                          <div className="col-md-5 pt-10">
                           
                            <div className="form-group mx-0">
                              <img
                                className="img upload-img mb-5"
                                alt=""
                                src={
                                  image
                                    ? image
                                    : "images/default.png"
                                }
                              />
                            </div>
                          </div>
                          
                        </div>
                      </form>
                    </div>
                  </div>
                  
                </div>
                  <div className="box box-primary bg-ddd ">
                    <div className="box-header with-border">
                      <h3 className="box-title mt-5">
                      Results
                      </h3>

                    </div>
                    <div className="box-body">
                          <div className="row">
                            <div className="col-md-12">
                                <PollReportBarChart key={poll_results} poll_results={poll_results} />
                            </div>
                        </div>
                    </div>
                  </div>
              </div>
            </div>
          </section>
        </div>
        <Footer />
      </div>
    );

}
